<div class="cr-editor-v2-root">
  <!-- Proof/Annotate hide the editing chrome (top bar, block sidebar), as in the mockup -->
  <app-navbar-v2
    *ngIf="!reviewActiveV2"
    [channelLabel]="channelLabel"
    [templateName]="templateName"
    (templateNameChange)="onTemplateNameChangeV2($event)"
    [suggestions]="suggestions"
    (searchTemplate)="searchTemplate($event)"
    (selectTemplate)="setTemplateName($event)"
    [namePlaceholder]="namePlaceholder"
    [emptyMessage]="emptyMessage"
    [idcustom]="idcustom"
    [showTranslateButton]="showTranslateButton"
    [showResponsysButton]="showResponsysButton"
    [showConnectCampaign]="showConnectCampaignV2"
    [deleteDisabled]="deleteDisabledV2"
    [exportDisabled]="exportDisabledV2"
    [duplicateDisabled]="duplicateDisabledV2"
    [translateDisabled]="translateDisabledV2"
    [connectCampaignDisabled]="connectCampaignDisabledV2"
    [saveResponsysDisabled]="saveResponsysDisabledV2"
    [channelFilterChips]="channelFilterChips"
    [activeChannelFilter]="activeChannelFilter"
    [channelSearchMatches]="channelSearchMatches"
    [channelSearchLoading]="channelSearchLoading"
    (back)="confirmGoBackV2(unsavedChangesModal)"
    (deleteClick)="confirmTableDeletion(deleteModal)"
    (exportClick)="exportDialogOpenV2 = true"
    (duplicateClick)="copyTemplate()"
    (translateClick)="translateTemplate()"
    (connectCampaignClick)="connectToCampaign(idcustom)"
    (saveResponsysClick)="saveV2(true)"
    (channelSearchOpened)="onChannelSearchOpened()"
    (channelSearchTermChange)="onChannelSearchTermChange($event)"
    (channelSearchFilterChange)="onChannelSearchFilterChange($event)"
    (channelSearchResultClick)="onChannelSearchResultClick($event)"
  ></app-navbar-v2>

  <div class="cr-main-layout">
    <app-sidebar-v2
      [blocks]="sidebarBlocks"
      [blockCatalog]="blockCatalog"
      [selectedBlockId]="selectedBlockId"
      [collapsed]="sidebarCollapsed || reviewActiveV2"
      [dragDisabled]="sidebarDragDisabled"
      [showAddBlock]="enableBlockToolbar && !isTranslator"
      [addBlockDisabled]="addBlockDisabledV2"
      (selectBlock)="selectBlockV2($event)"
      (reorder)="onSidebarReorderV2($event)"
      (toggleCollapsed)="toggleSidebarV2()"
      (deleteBlock)="onRemoveBlockV2($event)"
      (duplicateBlock)="duplicateBlockV2($event)"
      (addBlockAtEnd)="openSidebarAddBlockV2()"
    ></app-sidebar-v2>

    <app-add-block-modal-v2
      *ngIf="sidebarAddBlockOpen"
      [blockData]="sidebarAddBlockContext"
      [selectedBlocks]="selectedBlocks"
      [blockSelect]="blockSelect"
      (closeModal)="sidebarAddBlockOpen = false"
      (blockSelectEvent)="onSidebarAddBlockSelected($event)"
    ></app-add-block-modal-v2>

    <div class="cr-center-col">
      <app-channel-navbar-v2
        [isReadonlyMode]="isReadonly()"
        [selectedLanguage]="selectedLanguage"
        [languageDisabled]="isCopy || isTranslator"
        [lockInfo]="lockInfoV2"
        [warningMessage]="warningMessageV2"
        [deviceMode]="deviceMode"
        [saveDisabled]="saveDisabledV2"
        [saveLabel]="saveLabelV2"
        [editDisabled]="!isNew && !isMyLock()"
        [reviewMode]="reviewStateV2.mode"
        [shareUrl]="shareUrlV2"
        (setViewMode)="onSetViewModeV2($event)"
        (setReviewMode)="setReviewModeV2($event)"
        (languageChange)="selectedLanguage = $event; onLanguageChange()"
        (toggleLock)="toggleLockV2()"
        (refresh)="reloadPage()"
        (setDeviceMode)="setDeviceModeV2($event)"
        (save)="saveV2()"
        [canUndo]="editorHistory.canUndo"
        [canRedo]="editorHistory.canRedo"
        (undo)="undoV2()"
        (redo)="redoV2()"
      ></app-channel-navbar-v2>

      <app-preview-v2
        [blocks]="reviewActiveV2 ? reviewPreviewBlocksV2 : previewBlocks"
        [allBlocks]="reviewActiveV2 ? reviewAllBlocksV2 : selectedBlocks"
        [selectedBlockId]="reviewActiveV2 ? null : selectedBlockId"
        [deviceMode]="deviceMode"
        [blockSelect]="blockSelect"
        [addBlockDisabled]="addBlockDisabledV2"
        [showAddBlock]="enableBlockToolbar && !isTranslator"
        [isReadonlyMode]="isReadonly() || reviewActiveV2"
        [reviewMode]="reviewStateV2.mode"
        [reviewEmpty]="reviewStateV2.latest === null"
        [languageLabel]="languageLabelV2"
        (pullVersion)="requestCreateVersionV2(null)"
        (selectBlock)="selectBlockV2($event)"
        (blockSelectEvent)="handleBlockChangeEvent($event)"
        (blockDataChange)="onBlockDataUpdated($event)"
        (focusBlock)="focusBlockV2($event)"
        (inlineEditCommit)="onInlineEditCommitV2($event)"
      ></app-preview-v2>
    </div>

    <app-edit-block-comments-v2
      [selectedBlock]="selectedBlockObj"
      [selectedBlockId]="selectedBlockId"
      [allBlocks]="selectedBlocks"
      [alwaysVisibleBlocks]="alwaysVisibleBlocks"
      [activeTab]="rightPanelTab"
      [blockCatalog]="blockCatalog"
      [fieldsDisabled]="isReadonly()"
      [reviewMode]="reviewStateV2.mode"
      [currentUsername]="currentUser?.username ?? null"
      [languageLabel]="languageLabelV2"
      [canRestore]="isMyLock()"
      [commentCount]="reviewStateV2.comments.length"
      (newVersion)="openCreateVersionDialogV2()"
      (restoreVersion)="openRestoreDialogV2($event)"
      (closeSelected)="closeSelectedBlockV2()"
      (setTab)="setRightPanelTabV2($event)"
      (blockData)="onBlockDataUpdated($event)"
      (removeBlockEvent)="onRemoveBlockV2($event)"
      (jumpToBlock)="selectBlockV2($event)"
      (focusBlock)="focusBlockV2($event)"
    ></app-edit-block-comments-v2>
  </div>
</div>

<app-export-dialog-v2
  *ngIf="exportDialogOpenV2"
  [templateName]="templateName"
  [language]="selectedLanguage"
  [selectedBlocks]="selectedBlocks"
  [variablesMaxLength]="variablesMaxLength"
  (closeDialog)="exportDialogOpenV2 = false"
></app-export-dialog-v2>

<app-version-dialog-v2
  *ngIf="versionDialogV2"
  [mode]="versionDialogV2.mode"
  [targetVersion]="versionDialogV2.target"
  [resultVersion]="(reviewStateV2.latest ?? 0) + 1"
  [languageLabel]="languageLabelV2"
  [showUnsavedNote]="hasUnsavedChangesV2 || (versionDialogV2.mode === 'create' && isNew)"
  [busy]="versionBusyV2"
  (confirm)="confirmVersionDialogV2($event)"
  (closeDialog)="versionDialogV2 = null"
></app-version-dialog-v2>

<!-- Delete-confirmation modal - unchanged from template-editor.component.html -->
<ng-template #unsavedChangesModal let-modal class="modal">
  <div class="modal-header">
    <h4 class="modal-title">Leave without saving?</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
  </div>
  <div class="modal-body">You have unsaved changes that will be lost if you leave this page.</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="leaveWithoutSavingV2()">Leave anyway</button>
    <button type="button" class="btn btn-primary" (click)="activeModal.close()">Cancel</button>
  </div>
</ng-template>

<ng-template #deleteModal let-modal class="modal">
  <div class="modal-header">
    <h4 class="modal-title">Delete {{ templateName }}?</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activateMenuStatusModal()"></button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="deleteTable()">Delete table</button>
    <button type="button" class="btn btn-primary" (click)="activateMenuStatusModal()">Cancel</button>
  </div>
</ng-template>

<app-heartbeat
  [idcustom]="idcustom || undefined"
  [lockedBy]="lockedBy.username || undefined"
  [type]="heartbeatType"
></app-heartbeat>
